<script>
export default {
  name: 'CollapsingContainer',
  props: {
    isOpen: Boolean
  },
  methods: {
    beforeLeave (el) {
      el.style.height = el.scrollHeight + 'px'
      el.style.opacity = '1'
    },
    leave (el) {
      setTimeout(() => {
        el.style.height = '0'
        el.style.opacity = '0'
      })
    },
    afterLeave () {
      this.$emit('onHidden')
    },
    beforeEnter (el) {
      el.style.height = '0'
      el.style.opacity = '0'
    },
    enter (el) {
      el.style.height = el.scrollHeight + 'px'
      el.style.opacity = '1'
    },
    afterEnter () {
      this.$emit('onOpen')
    }
  }
}
</script>

<template>
  <transition
    @before-enter="beforeEnter"
    @enter="enter"
    @after-enter="afterEnter"
    @before-leave="beforeLeave"
    @leave="leave"
    @after-leave="afterLeave"
  >
    <div v-show="isOpen" class="collapsing-container">
      <slot></slot>
    </div>
  </transition>
</template>

<style scoped lang="scss">
.collapsing-container {
  overflow: hidden;
  transition: height 300ms, opacity 300ms;
}
</style>
